import { forwardRef, type Ref, type SVGProps } from "react";
const IconChevronRightCircleFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M30 16a14 14 0 1 0-14 14c10.4 0 14-9 14-14m-16.7 6.7a1 1 0 0 1 0-1.4l5.3-5.3-5.3-5.3a1 1 0 0 1 0-1.4 1 1 0 0 1 1.4 0l6 6a1 1 0 0 1 0 1.4l-6 6a1 1 0 0 1-1.4 0"
    />
  </svg>
);
const ForwardRef = forwardRef(IconChevronRightCircleFilledSVG);
ForwardRef.displayName = "IconChevronRightCircleFilled";
export { ForwardRef as IconChevronRightCircleFilled };
